<template>
  <div id="chart">
    <apexchart
      width="100%"
      height="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  props: ["dados", "cores"],
  data() {
    return {
      colors: [],
      labels: [],
      series: [],
    };
  },

  computed: {
    options() {
      return {
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              labels: {
                show: true,
                value: {
                  show: true,
                  fontSize: "13.5px",
                  color: "#000",
                  formatter: (val) => {
                    return `
                      Total: ${val}
                      Média: ${this.Helpers.formatarValorComCasas(
                        val / 13,
                        2
                      )}
                    `;
                  },
                },
                total: {
                  show: true,
                  color: "#333",
                },
              },
            },
          },
        },
        chart: {
          type: "donut",
        },
        title: {
          position: "top",
          text: "Análise por Tipo Percepção",
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: "Arial",
          },
        },
        grid: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: -10,
          },
        },
        dataLabels: {
          enabled: true,
        },
        labels: this.labels,
        legend: {
          show: false,
        },
        colors: this.colors,
        tooltip: {
          enabled: false,
          shared: false,
          y: {
            formatter: (val) => {
              return (
                this.Helpers.formatarValor(val / 13) + " Média"
              );
            },
          },
        },
      };
    },
  },

  watch: {
    dados() {
      this.montaGrafico();
    },
  },

  mounted() {
    this.montaGrafico();
  },

  methods: {
    montaGrafico() {
      this.labels = [];
      this.series = [];
      this.colors = [];

      Object.keys(this.dados).forEach((key) => {
        let name = "";
        let total = 0;

        Object.values(this.dados[key]).forEach((value) => {
          if (name == "") name = this.correcaoPortugues(value.status_percepcao);
          total += value.ocorrencias;
        });

        this.labels.push(name);
        this.colors.push(this.cores[key]);
        this.series.push(total);
      });

      // this.options = {
      //   labels: this.options.labels,
      //   colors: this.options.colors,
      // };
    },

    correcaoPortugues(str) {
      return str
        .replace("PERCEPCAO COM", "")
        .replace("PERCEPCAO EM", "")
        .replace("CA", "ÇÃ");
    },
  },
};
</script>
